import React from 'react';
import FsFormFullWidthContainer from 'ui-elements/form-elements/FsFormFullWidthContainer';
import FsPasswordInput from 'ui-elements/form-elements/FsPasswordInput';
import defaultLocales from 'globals/locales/default';

const getLabel = (fieldName: string): string => {
  switch (fieldName) {
    case 'currentPassword':
      return defaultLocales.currentPassword;
    case 'newPassword':
      return defaultLocales.newPassword;
    case 'repeatNewPassword':
      return defaultLocales.repeatNewPassword;
    default:
      return '';
  }
};

export interface PasswordUpdateSingleRowDataProps {
  name: string;
  value: string;
}

export interface PasswordUpdateSingleRowProps
  extends PasswordUpdateSingleRowDataProps {
  onChange?: ({ value, name }: PasswordUpdateSingleRowDataProps) => void;
}

const PasswordUpdateSingleRow: React.FC<PasswordUpdateSingleRowProps> = ({
  name = '',
  value = '',
  onChange,
}) => {
  const handleChange = async (newValue: string) => {
    if (onChange) onChange({ name, value: newValue });
  };

  return (
    <FsFormFullWidthContainer>
      <FsPasswordInput
        name={name}
        label={getLabel(name)}
        value={value}
        onChange={(e) => handleChange(e.target.value)}
        fsVariant="outlined"
        fullWidth
        required
        type="password"
        showStrengthChecker={name === 'newPassword'}
        showInfo={name === 'newPassword'}
      />
    </FsFormFullWidthContainer>
  );
};

export default PasswordUpdateSingleRow;
